'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationButtonStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  left: _propTypes2.default.bool,
  right: _propTypes2.default.bool
};

var defaultProps = {
  left: false,
  right: false
};

var margin = function margin(_ref) {
  var left = _ref.left,
      right = _ref.right,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.breadcrumbs.navigation;

  return (0, _styledComponents.css)(['', ' ', ''], left && 'margin-right: ' + (0, _reactackleCore.getValueString)(path.margin), right && 'margin-left: ' + (0, _reactackleCore.getValueString)(path.margin));
};

var NavigationButtonStyled = exports.NavigationButtonStyled = _styledComponents2.default.div.withConfig({
  displayName: 'NavigationButtonStyled'
})(['display:flex;align-items:center;', ''], margin);

NavigationButtonStyled.propTypes = propTypes;
NavigationButtonStyled.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-breadcrumbs/dist/styles/NavigationButtonStyled.js
// module id = 559
// module chunks = 0